export var clickList = function (){
    $('.dropdown-list').click(function (){
        $('.footer__list-icon', this).toggleClass('open-list')
        $(this).siblings('ul.footer__hidden-list').toggleClass('hide-list');
    })
}


// WEBPACK FOOTER //
// ./resources/assets/js/hidden-list.js